import { projectTypeDiscipline } from "../../../../../constants/projectTypes";

/**
 * Estimation page tab (Tank_Estimation's equipment tabs) that opens a
 * Structure / Instrumentation / Piping WBS's Estimation revisions.
 */
export const estimationTabLabel = (wbsType) => {
  const discipline = projectTypeDiscipline(wbsType);
  if (discipline === "struc") return "Structure";
  if (discipline === "ins") return "Instrumentation";
  return "Piping";
};

/**
 * Next free revision number for a loaded list of revision-bearing entries,
 * matching how the modules' own "+ Add New Revision" numbers one. null while
 * the list hasn't loaded, so callers can tell "no revisions yet" (-> "0")
 * apart from "don't know yet".
 */
export const nextRevisionNumber = (revisionEntries) => {
  if (!Array.isArray(revisionEntries)) return null;
  const numbers = revisionEntries
    .map((entry) => Number(entry?.revision))
    .filter((value) => !Number.isNaN(value));
  return String(numbers.length ? Math.max(...numbers) + 1 : 0);
};

/**
 * Highest revision a list already holds - the one a new revision starts from,
 * since creating one copies the latest revision's data. null when the list
 * hasn't loaded, "" when it has but holds nothing yet.
 */
export const latestRevisionNumber = (revisionEntries) => {
  if (!Array.isArray(revisionEntries)) return null;
  const numbers = revisionEntries
    .map((entry) => Number(entry?.revision))
    .filter((value) => !Number.isNaN(value));
  return numbers.length ? String(Math.max(...numbers)) : "";
};
